
import React, { useEffect } from 'react';

const HeaderStyles = () => {
  useEffect(() => {
    const styles = `
      .nav-item {
        position: relative;
        padding: 0.5rem 0;
        font-size: 14px;
        font-weight: 500;
        color: #1A2033;
        transition: color 0.2s ease;
      }
      
      .nav-item:hover {
        color: #0a2440;
      }
      
      .nav-item.active {
        color: #0a2440;
      }
      
      .nav-item.active::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #0a2440;
        border-radius: 2px;
      }
      
      @media (max-width: 768px) {
        .nav-item {
          padding: 0.75rem 0;
          width: 100%;
        }
        
        .nav-item.active::after {
          bottom: 0px;
        }
      }
    `;

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return null;
};

export default HeaderStyles;
